export default "__VITE_ASSET__BqRrbBhE__"